export class TimeZonesEntity {
    id!: string;
    displayName!: string;
  }